// @flow
import React from 'react';
import styled from 'styled-components';
import { SpinnerButton } from 'trustar-2.0/components/Button';
import {inDarkMode} from 'trustar-2.0/themes/common';

export const Container = styled.div`
  padding: 1.5rem 4rem 1rem 4rem;
  overflow-y: auto;
  height: 100%;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  span {
    color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
  }

  p {
    font-weight: 300;
  }

  .btn.btn-secondary {
    color: white;
  }
`;

export const TableTitle = styled.h1`
  && {
    margin-bottom: 2rem;

    &.digestTitle,
    &.watchKeywordsTitle {
      margin-bottom: 1rem;
    }
  }
`;

export const Table = styled.table`
  && {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
`;

export const Head = styled.thead`
  border-bottom: 1px solid ${({ theme }) => theme.ThemeColors.TEXT.X100};
  margin-bottom: 2rem;
`;

export const HeadCell = styled.th``;

export const Row = styled.tr``;

export const LabelCell = styled.td`
  padding-top: 1rem;
  width: 50%;
  margin-right: 3rem;
`;

export const SettingCell = styled(LabelCell)`
  text-align: center;
  vertical-align: middle;
`;

export const SettingCellComplex = styled(LabelCell)`
  && {
    text-align: left;
    vertical-align: top;
    padding-left: 3rem;
    padding-right: 1rem;
  }
`;

export const ColumnTitle = styled.h3`
  && {
    font-weight: 300;
    line-height: 1.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const SettingTitle = styled(ColumnTitle)`
  && {
    font-weight: bold;
    text-align: center;
  }
`;

export const PreferenceTitle = styled.h3`
  && {
    line-height: 1.5;
    font-weight: bold;
    margin-bottom: 0.25rem;
  }
`;

export const PreferenceDescription = styled.p``;

export const SectionBreak = styled.hr`
  && {
    border-top: 1px solid ${({ theme }) => theme.ThemeColors.TEXT.X100};
    margin-bottom: 1.833rem;
    margin-top: 1.833rem;
  }
`;

export const CheckboxInput = (props: Object) => (
  <Input className='help' {...props} />
);

export const Loader = (props: Object) => {
  const Wrapper = styled.div`
    && {
      width: 100%;
    }
  `;
  const loadingMessage = <Wrapper>Your preferences are loading.</Wrapper>;
  return props.isLoading ? loadingMessage : <Wrapper>{props.children}</Wrapper>;
};

export const Input = styled.input`
  && {
    margin-right: 0.25rem;
  }

  &:not(:first-child) {
    margin-left: 2rem;
  }
`;

export const InputLabel = styled.label`
  && {
    margin-left: 0.5rem;
  }
`;

export const InputContainer = styled.div`
  margin-top: 1rem;
`;

export const SettingInstruction = styled.h6`
  && {
    font-size: 1rem;
    color: ${({ theme }) => theme.ThemeColors.LINK_TEXT.X700};
    font-weight: 300;

    &.unsubscribeToggle {
      font-weight: bold;
      color: ${({ theme }) => theme.ThemeColors.TEXT.hex};
      margin-bottom: 1rem;
    }
  }
`;

export const UpdateButton = SpinnerButton;

export const SpecialSection = styled.div`
  && {
    background: ${({ theme }) => inDarkMode(theme) ? theme.ThemeColors.SURFACE_LIGHTER : theme.ThemeColors.SEARCH_FILTER_BAR.X200};
  }
  padding-left: 19px;
  padding-right: 19px;
  padding-top: 22px;
  padding-bottom: 22px;
  min-height: 189px;
  border: 1px solid ${({ theme }) => theme.ThemeColors.BORDER.hex};
`;

export const TableBody = styled.tbody``;



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Layouts/PreferenceTable.js